import React from 'react';

import WeeklyScheduleTimeTable from './WeeklyScheduleTimeTable';

type Props = {
  areaUsages: any;
};

const timeTable = {
  width: `calc(100% - 60px)`,
  display: 'flex',
  margin: 0,
  padding: 0
};

const ScheduleTimeArea = (props: Props) => {
  const { areaUsages } = props;
  const startTime = areaUsages.usageStartTime;
  const endTime = areaUsages.usageEndTime;

  return (
    <div style={timeTable}>
      {areaUsages.availability.map((value: any) => (
        <WeeklyScheduleTimeTable
          section={value.date}
          startTime={startTime.slice(0, 6)}
          endTime={endTime.slice(0, 6)}
          sectionData={value}
          key={`weeklyScheduleTimeTable${value.date}`}
        />
      ))}
    </div>
  );
};
export default ScheduleTimeArea;
